import Vue from 'vue'
import store from '@packages/store'

export default {

    async list({pagination, filters}) {
        const list = await Vue.api.advertising.list({pagination, filters})
        store.commit('CONNECTIONS_SET_LIST', list)
        return list
    },

    async count({filters}) {
        const count = await Vue.api.advertising.count({filters})
        store.commit('CONNECTIONS_SET_COUNT', count)
        return count
    }

}
